import { jwtDecode } from "jwt-decode";
import { getSessionToken as getDescopeSessionToken } from "@descope/react-sdk";

export interface TokenClaims {
  sub: string;
  name: string;
  /** Email when present in the token. */
  email?: string;
  preferred_language?: string;
}

/** Helper: extract the `email` claim from an arbitrary token payload. */
export function extractEmailFromPayload(payload: Record<string, unknown> | null | undefined): string | undefined {
  if (!payload) return undefined;
  const email = payload['email'];
  if (typeof email === 'string') return email;
  return undefined;
}

function claimsFromDescopeSession(): TokenClaims | null {
  const descopeToken = getDescopeSessionToken();
  if (!descopeToken) return null;
  const payload = decodeToken(descopeToken) as Record<string, unknown> | null;
  if (!payload?.['sub']) return null;
  return {
    sub: payload['sub'] as string,
    name: (payload['name'] as string) || '',
    email: extractEmailFromPayload(payload),
    preferred_language: payload['preferred_language'] as string | undefined,
  };
}

/**
 * Reads the current user's claims from `getFallbackClaims` — which defaults to decoding
 * Descope's session token (Center-PWA, EAINT-954 Phase 4). A host app with another auth
 * stack supplies its own `getFallbackClaims`, which keeps this module free of any
 * auth-stack-specific dependency beyond the Descope default.
 */
export function getTokenClaims(getFallbackClaims: () => TokenClaims | null = claimsFromDescopeSession): TokenClaims | null {
  return getFallbackClaims();
}

export function decodeToken(token: string): any {
  try { return jwtDecode(token); }
  catch { return null; }
}
